<template>
  <div class="table-responsive">
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <div class="col-sm-12 col-md-12 mb-4">
        <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0 font-14 font-weight-bold">
            {{ $t("history") }}
          </p>
          <TableSearch :left="'left:18px'" @handleSearch="handleSearch" />
        </div>
      </div>
      <div class="row" style="height: 33rem; overflow: auto;">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead class="data-table-bg">
              <tr>
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody v-if="this.stats.length !== 0">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="cursor: pointer; text-align: left;"
                :class="{
                  'data-table-bg': index % 2 !== 0,
                }"
              >
                <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  {{ $t("no-read") }}
                </td>
                <!-- <td>{{ data.column2 }}</td> -->
                <td>{{ data.column3 }}</td>
                <td style="max-width: 16rem;">{{ data.column4 }}</td>
              </tr>
            </tbody>
            <tbody v-else align="center">
              <tr align="center">
                <td colspan="6">
                  {{ $t("no_sms") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        :pageCount="pageCount"
        :data="paginatedData"
        :sizeperpage="sizeperpage"
        :pageNumber="pageNumber"
        :pages="pages"
        @goToLastPage="goToLastPage"
        @nextPage="nextPage"
        @handlePageChange="handlePageChange"
        @goToFirstPage="goToFirstPage"
        @prevPage="prevPage"
        @onchange="onchange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import TableSearch from "./TableSearch.vue";
import Pagination from "./PaginationNew.vue";
import tableMixin from "../mixins/tableMixinWithBackend";

export default {
  name: "WalletHistoryTable",
  props: {
    stats: Array,
    paginationMeta: Object,
  },
  data() {
    return {
      dataTable: [],
    };
  },
  mixins: [tableMixin],
  watch: {
    stats: {
      handler: function() {
        this.dataTable = [];
        for (let i = 0; i < this.stats.length; i++) {
          let date = this.stats[i].createdAt;
          date = moment(date).format("MMM Do YYYY, hh:mm a");
          this.dataTable.push({
            date: date,
            // column2: this.stats[i].oldUnits,
            column3: this.stats[i].units,
            column4: this.stats[i].amount,
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    tableColumns() {
      return [
        [this.$t("date_pur"), "column1"],
        // [this.$t("num_sms_time"), "column2"],
        [this.$t("num_units"), "column3"],
        [this.$t("amt", { name: "NGN" }), "column4"],
      ];
    },
  },
  methods: {
    valueUnit(val, title) {
      if (title == "Battery") {
        return val + "%";
      } else if (title == "Humidity" || title == "Temperature") {
        return val + "°C";
      } else return val;
    },
  },
  components: { Pagination, TableSearch },
};
</script>

<style scoped>
th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
</style>
<i18n>
{
	"en": {
		"Search": "Search",
		"alm_type": "Alarm Type",
		"alm_val": "Alarm Value",
		"amt": "Amount {name}",
		"batt": "Battery {name}",
		"comment": "Comment",
		"date_pur": "Date Purchased",
		"date_time": "Date/Time",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"dev_imei": "Device IMEI",
		"entries": "entries",
		"last-seen": "Last Seen",
		"msg": "Message",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"no_alm_yet": "You have no alarm yet",
		"no_sms": "You have no sms currently",
		"num_sms_time": "Number of SMS purchased over time",
		"num_units": "Number of Units",
		"of": "of",
		"phone": "Phone Number",
		"prev": "Previous",
		"readings": "readings",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
		"alm_type": "Tipo de alarma",
		"alm_val": "Valor de alarma",
		"amt": "Importe {name}",
		"batt": "Batería {name}",
		"comment": "Comentario",
		"date_pur": "Fecha de compra",
		"date_time": "Fecha y hora",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"dev_imei": "IMEI del dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"msg": "Mensaje",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"no_alm_yet": "Todavía no tienes alarma",
		"no_sms": "Actualmente no tienes sms",
		"num_sms_time": "Número de SMS comprados a lo largo del tiempo",
		"num_units": "Número de unidades",
		"of": "de",
		"phone": "Número de teléfono",
		"prev": "Anterior",
		"readings": "Lecturas",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
		"alm_type": "Type d'alarme",
		"alm_val": "VALEUR D'ALARME",
		"amt": "Montant {name}",
		"batt": "Batterie {name}",
		"comment": "Commentaire",
		"date_pur": "Date d'achat",
		"date_time": "Date / heure",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"dev_imei": "IMEI de l'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"msg": "Message",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"no_alm_yet": "Vous n'avez pas encore d'alarme",
		"no_sms": "Vous n'avez pas de sms actuellement",
		"num_sms_time": "Nombre de SMS achetés au fil du temps",
		"num_units": "Nombre d'unités",
		"of": "De",
		"phone": "Numéro de téléphone",
		"prev": "précédent",
		"readings": "Lectures",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"alm_type": "Aina ya Kengele",
		"alm_val": "Thamani ya Kengele",
		"amt": "Kiasi {name}",
		"batt": "Betri {name}",
		"comment": "Maoni",
		"date_pur": "Tarehe Iliyonunuliwa",
		"date_time": "Tarehe/Saa",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"dev_imei": "IMEI ya kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"msg": "Ujumbe",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"no_alm_yet": "Bado huna kengele",
		"no_sms": "Huna sms kwa sasa",
		"num_sms_time": "Idadi ya SMS zilizonunuliwa kwa muda",
		"num_units": "Idadi ya Vitengo",
		"of": "ya",
		"phone": "Nambari ya simu",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"to": "Kwa"
	}
}
</i18n>
